
<template>
  <div class="container  mt-3">
    <div class="m-auto">
    	
      <div class="form-horizontal">
        
          <div class="form-group row">
            <label class="col-12 col-sm-4 col-form-label">Sede</label>
            <div class="col-12 col-sm-4">
              <select v-model="sede_id" class="form-control">
                <option disabled value="">Please select one</option>
                <option v-if="opciones" v-for="opcion in opciones" :value="opcion.id">{{ opcion.nombre }}</option>
              </select>
            </div>
            <div class="col-12 col-sm-4">
              <button v-if="procesable" class="btn btn-block btn-danger" @click="procesarObservacion">
                Cambiar Sede
              </button>
              <span>Recuerde que los funcionarios de la sede actual perderán visibilidad sobre este estudiante. </span> 
            </div>  
          </div>
      </div>
    </div>
    
    <b-modal @ok="procesar" @cancel="observacion=''" v-model="changeObservacion"  id="modalObservacion"
    :ok-disabled="registrarObservacion && observacion.length<observacionMin"  title="Motivo del cambio">
    <div class="mb-1">
      <p>¿Estas seguro de realizar este cambio de sede de {{sede_anterior}} a {{sede_nueva}}?</p>
    </div>
      <div class="mb-2" v-if="registrarObservacion">
        
        <b-form-textarea
          id="textarea"
          v-model="observacion"
          placeholder="Cuéntanos, ¿por qué es necesario hacer este cambio?"
          rows="3"
          max-rows="6"
          maxlength="100"
        ></b-form-textarea>
        <pre class="d-block text-right">{{ observacion.length }}/{{ observacionMin }}</pre>
      </div>
    </b-modal>

  </div>
</template>

<script>
  import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
  import Vue from 'vue';

  export default {
    name: 'DetalleSede',
    components: {
      
    },
    data () {
      return {
        sede_id:null,
        
        changeObservacion:false,
        observacionMin:10,
        observacion:''
      }
    },
    props: {
      estudiante: Object
    },
    mounted () {
      if(!this.opciones || (this.opciones && this.opciones.length==0)){
        this.fetchSedes()
      }
      if(this.estudiante){
        this.sede_id = this.estudiante.sede_id  
      }else{
        console.log('Hay que asegurarse de tener un estudiante antes de utilizar el componente DetalleSede')
      }
    },
    methods:{
      ...mapActions({
        fetchSedes: 'sedes/fetchLista',
        fetchDetalle: 'estudiantes/fetchDetalle',
        setWarning: 'setWarning',
      }),
      ...mapMutations({
        
      }),
      procesar(){
        
        Vue.http.post('user/cambiar_sede',{
          id:this.estudiante.id,
          sede_id:this.sede_id,
          observacion:this.observacion
        })
          .then((response)=>{
             this.limpiar()
	          this.setWarning('Sede cambiada', { root: true }).then(()=>{
	            this.$router.push('/estudiantes')
	          })
          }).catch((response)=>{
            this.setWarning(response.data, { root: true })
          })
      },
      procesarObservacion(){
        this.changeObservacion = true;
        this.observacion = '';
      },
      limpiar(){
        this.curso_id = null
      }
    },
    computed:{
      ...mapState({
        opciones: state  => state.sedes.lista,
      }),
      ...mapGetters({
        
      }),
      procesable: {
        get () {
          return (this.sede_id && this.sede_id != this.estudiante.sede_id)
        },
        set(value){}
      },
      registrarObservacion(){
        const franquicia = [17,18,32];
        const online = [30];
        if (franquicia.includes(this.sede_id) && !franquicia.includes(this.estudiante.sede_id)) {
          return true;
        } else if (!franquicia.includes(this.sede_id) && franquicia.includes(this.estudiante.sede_id)) {
          return true;
        } else if (online.includes(this.sede_id) && !online.includes(this.estudiante.sede_id)) {
          return true;
        } else if (!online.includes(this.sede_id) && online.includes(this.estudiante.sede_id)) {
          return true;
        }
        return false;
      },
      sede_anterior(){ 
        let sede = this.opciones.find(x => x.id == this.estudiante.sede_id);
        return sede && sede.nombre ? sede.nombre : "";
      },
      sede_nueva(){ 
        let sede = this.opciones.find(x => x.id == this.sede_id);
        return sede && sede.nombre? sede.nombre : "";
      },
    }
  }
</script>

<style scope>
  .programar_wrapper .form-container{
      
  }
	.programar_wrapper{
    
	}
</style>

